/* AdVille per Clo's Fashion and Beauty. Generato da theme_work/js.py, non si modifica a mano.
   Differenza unica dal prototipo: il carrello e' quello vero dello store. */
window.AV = (function(){
  var SITO = "", CDN = "https://cdn.shopify.com/s/files/1/0940/4393/1008/files/";
  var SOGLIA = 90.00, SPED = 9.90;
  var INSIEME = window.AV_INSIEME || [];
  var CHIAVE = "av-carrello-clos";

  function esc(t){return String(t).replace(/&/g,"&amp;").replace(/</g,"&lt;")
    .replace(/>/g,"&gt;").replace(/"/g,"&quot;")}
  function euro(n){return n.toFixed(2).replace(".",",")+"&euro;"}
  function $(s,r){return (r||document).querySelector(s)}

  // ---- il carrello vero dello store ------------------------------------
  // Qui siamo sul dominio del negozio, quindi /cart/add.js e /cart.js si
  // possono chiamare davvero. Le righe restano nella stessa forma che usa il
  // resto del file ({id,q,p,t,m,f,et,h}), cosi' il cassetto, il foglio delle
  // taglie e il cross-sell non cambiano di una riga.
  var RIGHE = [];          // l'ultima fotografia del carrello dello store
  var inVolo = 0;          // quante chiamate sono in corso

  function leggi(){ return RIGHE }

  function daShopify(c){
    // Shopify da' i prezzi in centesimi e il titolo della variante come
    // "black / M": la taglia e' l'ultimo pezzo, che e' la stessa regola di
    // taglia_sola() in Python.
    return (c.items || []).map(function(x){
      var et = "";
      if(x.variant_title){
        var parti = String(x.variant_title).split("/");
        et = parti[parti.length-1].trim();
      }
      return {id:String(x.variant_id), q:x.quantity, p:x.final_price/100,
              t:x.product_title, m:x.vendor || "", f:x.image || "",
              et:et, h:x.handle || ""};
    });
  }

  function aggiorna(poi){
    inVolo++;
    fetch("/cart.js", {headers:{"Accept":"application/json"}})
      .then(function(r){ return r.json() })
      .then(function(c){ RIGHE = daShopify(c); })
      .catch(function(){})
      .then(function(){ inVolo--; disegna(); if(poi) poi(); });
  }

  function scrivi(){ /* sul tema scrive lo store, non il browser */ }

  function totale(r){ var t=0; for(var i=0;i<r.length;i++) t += r[i].p * r[i].q; return t }
  function pezzi(r){ var n=0; for(var i=0;i<r.length;i++) n += r[i].q; return n }

  function aggiungi(riga){
    // Si apre subito e si disegna dopo: aspettare la rete con il cassetto
    // chiuso fa sembrare che il pulsante non abbia fatto niente.
    apriCassetto();
    fetch("/cart/add.js", {
      method:"POST", headers:{"Content-Type":"application/json",
                              "Accept":"application/json"},
      body: JSON.stringify({items:[{id:parseInt(riga.id,10), quantity:1}]})
    }).then(function(r){ return r.json() })
      .then(function(){ aggiorna() })
      .catch(function(){ aggiorna() });
  }

  function quantita(id, d){
    var q = 0;
    for(var i=0;i<RIGHE.length;i++) if(RIGHE[i].id === id) q = RIGHE[i].q + d;
    if(q < 0) q = 0;
    fetch("/cart/change.js", {
      method:"POST", headers:{"Content-Type":"application/json",
                              "Accept":"application/json"},
      body: JSON.stringify({id:id, quantity:q})
    }).then(function(r){ return r.json() })
      .then(function(){ aggiorna() })
      .catch(function(){ aggiorna() });
  }

  // Sul tema si va alla cassa, non si ricostruisce l'indirizzo del carrello:
  // le righe sono gia' dentro il carrello dello store.
  function linkPagamento(r){ return r.length ? "/checkout" : "/cart" }

  // ---- il disegno del cassetto ----------------------------------------
  function disegna(){
    var r = leggi(), tot = totale(r), n = pezzi(r);
    var c = $("#av-cassetto");

    var badge = document.querySelectorAll(".conta-c");
    for(var b=0;b<badge.length;b++){
      badge[b].textContent = n;
      badge[b].classList.toggle("vedi", n > 0);
    }
    if(!c) return;

    $(".cima .n", c).textContent = n ? "(" + n + ")" : "";

    // la barra della spedizione
    var sped = $(".sped", c), manca = SOGLIA - tot;
    sped.classList.toggle("piena", tot > 0 && manca <= 0);
    if(!n) $("p", sped).innerHTML = "Spedizione gratuita a partire da <b>" + euro(SOGLIA) + "</b>.";
    else if(manca > 0) $("p", sped).innerHTML = "Ti mancano <b>" + euro(manca) +
      "</b> alla spedizione gratuita. Sotto i " + euro(SOGLIA) + " la spedizione costa " + euro(SPED) + ".";
    else $("p", sped).innerHTML = "Spedizione gratuita: ci sei.";
    $(".asta i", sped).style.width = Math.min(100, tot / SOGLIA * 100) + "%";

    // le righe
    var d = $(".righe", c);
    if(!n){
      d.innerHTML = '<div class="vuoto-c">Il carrello &egrave; vuoto.</div>';
    } else {
      d.innerHTML = r.map(function(x){
        return '<div class="riga" data-id="'+x.id+'">'+
          '<img src="'+x.f+'" alt="" loading="lazy">'+
          '<div class="d"><div class="mk">'+esc(x.m)+'</div>'+
          '<div class="nm">'+esc(x.t)+'</div>'+
          (x.et ? '<div class="tg">Taglia '+esc(x.et)+'</div>' : '')+
          '<div class="b"><span class="qta">'+
            '<button type="button" data-q="-1" aria-label="Uno in meno">&minus;</button>'+
            '<span>'+x.q+'</span>'+
            '<button type="button" data-q="1" aria-label="Uno in più">+</button>'+
          '</span><span class="pz">'+euro(x.p * x.q)+'</span></div></div></div>';
      }).join("");
    }

    // il cross-sell: tre capi, e mai uno che e' gia' dentro
    var dentro = {};
    for(var i=0;i<r.length;i++) dentro[r[i].h] = 1;
    var pi = INSIEME.filter(function(x){ return !dentro[x.h] }).slice(0,3);
    var box = $(".insieme", c);
    box.hidden = !(n && pi.length);
    if(!box.hidden) $(".lista-i", box).innerHTML = pi.map(function(x){
      return '<div class="mini" data-h="'+x.h+'">'+
        '<img src="'+CDN+x.f+'&width=140" alt="" loading="lazy">'+
        '<div class="d"><div class="nm">'+esc(x.m)+' &middot; '+esc(x.t)+'</div>'+
        '<div class="pz">'+euro(x.p)+'</div></div>'+
        '<button type="button">Aggiungi</button></div>';
    }).join("");

    $(".somma", c).innerHTML = euro(tot);
    $(".paga", c).setAttribute("href", linkPagamento(r));
  }

  function apriCassetto(){
    var c = $("#av-cassetto");
    if(c && !c.open){ try{ c.showModal() }catch(e){ c.setAttribute("open","") } }
  }
  function chiudiCassetto(){ var c = $("#av-cassetto"); if(c && c.open) c.close() }

  // ---- il foglio delle taglie -----------------------------------------
  var inCorso = null;   // la scheda su cui si sta scegliendo

  function apriFoglio(card){
    var f = $("#av-foglio");
    if(!f) return;
    var v = JSON.parse(card.dataset.v || "[]");
    inCorso = card;
    $(".capo", f).innerHTML = '<img src="'+card.dataset.f+'" alt="">'+
      '<div><b>'+esc(card.dataset.m)+'</b><span>'+esc(card.dataset.t)+'</span>'+
      '<i>'+euro(parseFloat(card.dataset.p))+'</i></div>';
    $(".lista", f).innerHTML = v.map(function(x){
      return '<button type="button" data-id="'+x[1]+'" data-et="'+esc(x[0])+'">'+
        '<b>'+esc(x[0])+'</b><u>Aggiungi</u></button>';
    }).join("");
    try{ f.showModal() }catch(e){ f.setAttribute("open","") }
  }
  function chiudiFoglio(){ var f = $("#av-foglio"); if(f && f.open) f.close(); inCorso = null }

  function daScheda(card, et, id){
    return {id:id, h:(card.dataset.h||""), t:card.dataset.t, m:card.dataset.m,
            p:parseFloat(card.dataset.p), f:card.dataset.f, et:et||"", q:1};
  }

  // ---- la scheda prodotto, la stessa di card() ------------------------
  function scheda(p){
    var url = SITO+"/products/"+p.h;
    var fs = p.fs || [];
    var nastro = fs.map(function(f,i){
      return '<a href="'+url+'"'+(i?' tabindex="-1" aria-hidden="true"':'')+
        '><img src="'+CDN+f+'&width=520" alt="'+(i?'':esc(p.t))+
        '" loading="lazy" draggable="false"></a>';
    }).join("");
    var punti = "", frecce = "";
    if(fs.length>1){
      punti = '<div class="punti">'+fs.map(function(_,i){
        return '<i'+(i?'':' class="on"')+'></i>'}).join("")+'</div>';
      frecce = '<button class="fre pre" type="button" aria-label="Foto precedente" disabled>'+
        '‹</button><button class="fre suc" type="button" aria-label="Foto successiva">'+
        '›</button>';
    }
    var giu = p.pf>p.p ? Math.round((1-p.p/p.pf)*100) : 0;
    if(giu<3) giu = 0;
    var bollo = giu ? '<span class="bollo b-meno">-'+giu+'%</span>'
              : (p.s==="esaurito" ? '<span class="bollo b-fine">Momentaneamente finito</span>' : '');
    var pieno = giu ? '<span class="pieno">'+euro(p.pf)+'</span>' : '';
    var meno  = giu ? '<span class="meno">-'+giu+'%</span>' : '';
    var v = p.v || [];
    var taglie = "";
    if(p.s==="parziale" && v.length)
      taglie = '<div class="taglie">'+esc(v.slice(0,6).map(function(x){return x[0]}).join(", "))+'</div>';
    else if(p.s==="esaurito")
      taglie = '<div class="taglie">Avvisami quando torna</div>';
    var agg = "", dati = "";
    if(p.s!=="esaurito" && v.length){
      // la taglia sul pulsante solo se e' davvero una taglia: p.tu lo decide
      // in Python, cosi' "white" non diventa mai "Aggiungi &middot; white"
      agg = '<button class="agg" type="button">Aggiungi'+
            (p.tu ? " · "+esc(p.tu) : "")+'</button>';
      dati = ' data-v="'+esc(JSON.stringify(v))+'" data-t="'+esc(p.t)+'" data-m="'+esc(p.m)+
             '" data-p="'+p.p+'" data-f="'+CDN+(fs[0]||"")+'&width=200" data-h="'+esc(p.h)+'"';
    }
    return '<div class="card'+(p.s==="esaurito"?" spento":"")+'"'+dati+'>'+
      '<div class="ph"><div class="foto">'+nastro+'</div>'+bollo+punti+frecce+'</div>'+
      '<a class="testo" href="'+url+'">'+
        '<div class="marchio">'+esc(p.m)+'</div>'+
        '<div class="nome">'+esc(p.t)+'</div>'+
        '<div class="prezzi"><span class="p">'+euro(p.p)+'</span>'+pieno+meno+'</div>'+
        taglie+
      '</a>'+agg+'</div>';
  }

  // ---- i pallini del nastro foto --------------------------------------
  // `scroll` non risale, quindi si ascolta in cattura: e' l'unico modo di
  // prenderlo da schede che ancora non esistono.
  document.addEventListener("scroll", function(e){
    var f = e.target;
    if(!f || !f.classList || !f.classList.contains("foto")) return;
    var card = f.parentNode.parentNode;
    var punti = card.querySelectorAll(".punti i");
    if(!punti.length) return;
    var i = Math.round(f.scrollLeft / (f.clientWidth || 1));
    if(i < 0) i = 0;
    if(i > punti.length-1) i = punti.length-1;
    for(var k=0;k<punti.length;k++) punti[k].classList.toggle("on", k===i);
    var pre = card.querySelector(".fre.pre"), suc = card.querySelector(".fre.suc");
    if(pre) pre.disabled = (i<=0);
    if(suc) suc.disabled = (i>=punti.length-1);
  }, true);

  // ---- i tocchi --------------------------------------------------------
  document.addEventListener("click", function(e){
    var t = e.target;
    if(!t || !t.closest) return;

    var fre = t.closest(".fre");
    if(fre){
      e.preventDefault();
      var f = fre.parentNode.querySelector(".foto");
      if(f) f.scrollBy({left:(fre.classList.contains("pre")?-1:1)*f.clientWidth,
                        behavior:"smooth"});
      return;
    }

    // una taglia dentro il foglio
    var scelta = t.closest("#av-foglio .lista button");
    if(scelta){
      e.preventDefault();
      var card = inCorso;
      chiudiFoglio();
      if(card) aggiungi(daScheda(card, scelta.dataset.et, scelta.dataset.id));
      return;
    }
    if(t.closest("#av-foglio .annulla")){ e.preventDefault(); chiudiFoglio(); return }

    // il pulsante Aggiungi di una scheda
    var agg = t.closest(".agg");
    if(agg){
      e.preventDefault();
      var c2 = agg.parentNode;
      var v = JSON.parse(c2.dataset.v || "[]");
      if(v.length === 1) aggiungi(daScheda(c2, v[0][0], v[0][1]));
      else if(v.length) apriFoglio(c2);
      return;
    }

    // dentro il cassetto
    var q = t.closest(".cassetto .qta button");
    if(q){ e.preventDefault(); quantita(t.closest(".riga").dataset.id, +q.dataset.q); return }

    var mini = t.closest(".cassetto .mini button");
    if(mini){
      e.preventDefault();
      var h = t.closest(".mini").dataset.h;
      for(var i=0;i<INSIEME.length;i++) if(INSIEME[i].h === h){
        var x = INSIEME[i];
        aggiungi({id:x.id, h:x.h, t:x.t, m:x.m, p:x.p, f:CDN+x.f+"&width=200", et:x.et||"", q:1});
        break;
      }
      return;
    }
    if(t.closest(".cassetto .via")){ e.preventDefault(); chiudiCassetto(); return }

    // l'icona del carrello in testata apre il cassetto invece di portare via
    var ic = t.closest(".apri-cassetto");
    if(ic){ e.preventDefault(); disegna(); apriCassetto(); return }
  });

  // il velo di un <dialog>: un tocco fuori dal contenuto chiude
  ["#av-foglio","#av-cassetto"].forEach(function(sel){
    var d = $(sel);
    if(!d) return;
    d.addEventListener("click", function(e){ if(e.target === d) d.close() });
    d.addEventListener("close", function(){ if(sel === "#av-foglio") inCorso = null });
  });

  // ---- torna in cima ---------------------------------------------------
  (function(){
    var b = $(".su");
    if(!b) return;
    var atteso = false;
    function guarda(){
      atteso = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      b.classList.toggle("vedi", y > window.innerHeight * 1.5);
    }
    window.addEventListener("scroll", function(){
      if(!atteso){ atteso = true; requestAnimationFrame(guarda); }
    }, {passive:true});
    b.addEventListener("click", function(){
      var fermo = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
      window.scrollTo(fermo ? {top:0} : {top:0, behavior:"smooth"});
    });
    guarda();
  })();

  disegna();

  return {SITO:SITO, CDN:CDN, scheda:scheda, esc:esc, euro:euro,
          aggiungi:aggiungi, disegna:disegna, apriCassetto:apriCassetto, aggiorna:aggiorna};
})();
document.addEventListener('DOMContentLoaded', function(){
  if(window.AV && window.AV.aggiorna) window.AV.aggiorna();
});
